export const MCS_NAME = 'request-form-realtor-frontend';
